import auConfig from './auConfig';
import hkConfig from './hkConfig';
import idConfig from './idConfig';
import myConfig from './myConfig';
import nzConfig from './nzConfig';
import phConfig from './phConfig';
import sgConfig from './sgConfig';
import thConfig from './thConfig';

export enum Site {
  seekAU = 'candidate-seek-au',
  seekNZ = 'candidate-seek-nz',
  jobsdbHK = 'candidate-jobsdb-hk',
  jobsdbTH = 'candidate-jobsdb-th',
  jobstreetMY = 'candidate-jobstreet-my',
  jobstreetSG = 'candidate-jobstreet-sg',
  jobstreetPH = 'candidate-jobstreet-ph',
  jobstreetID = 'candidate-jobstreet-id',
}

export enum Env {
  development = 'development',
  staging = 'staging',
  production = 'production',
}

export const getConfigBasedOnSiteEnv = (site: Site, env: Env) => {
  switch (site) {
    case Site.seekAU:
      return auConfig[env];
    case Site.seekNZ:
      return nzConfig[env];
    case Site.jobsdbHK:
      return hkConfig[env];
    case Site.jobsdbTH:
      return thConfig[env];
    case Site.jobstreetMY:
      return myConfig[env];
    case Site.jobstreetSG:
      return sgConfig[env];
    case Site.jobstreetPH:
      return phConfig[env];
    case Site.jobstreetID:
      return idConfig[env];
  }
};
